'use strict';

module.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;